interface AdvanceRedirectInput {
  token: string
  redirectPath?: string
  advanceBaseUrl: string
  tv3BaseUrl: string
}

const TV3_FLAG = 'tv3'

function joinUrl(baseUrl: string, path: string) {
  const sanitizedBase = (baseUrl || '').replace(/\/+$/, '')
  const sanitizedPath = (path || '').replace(/^\/+/, '')
  return `${sanitizedBase}/${sanitizedPath}`
}

function buildReturnToUrl(tv3BaseUrl: string, token: string, redirectPath?: string) {
  const url = joinUrl(tv3BaseUrl, 'login')
  const params = new URLSearchParams()
  params.set('token', token)
  params.set('stayInTv3', 'true')
  if (redirectPath) {
    params.set('redirectURL', redirectPath)
  }
  return `${url}?${params.toString()}`
}

export function buildAdvanceRedirectUrl({ token, redirectPath, advanceBaseUrl, tv3BaseUrl }: AdvanceRedirectInput) {
  const advanceUrl = joinUrl(advanceBaseUrl, 'login')
  const params = new URLSearchParams()
  params.set('token', token)
  params.set('from', TV3_FLAG)
  params.set('redirectURL', redirectPath || '/')
  params.set('returnTo', buildReturnToUrl(tv3BaseUrl, token, redirectPath))
  return `${advanceUrl}?${params.toString()}`
}
